/* eslint-disable prefer-template */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import React, { FC } from "react";
import clsx from "clsx";
import { ReactComponent as ChevronLeft } from "../../assets/images/chevron-left.svg";
import { ReactComponent as ChevronRight } from "../../assets/images/chevron-right.svg";

type propsType = {
  className?: string;
  variant?: string;
};

const SwiperArrow: FC<propsType> = (props) => {
  const classes = clsx(
    "swiper--arrow",
    props.className,
    "swiper--" + props.variant
  );

  return (
    <div className={classes}>
      {props.variant === "prev" && <ChevronLeft />}
      {props.variant === "next" && <ChevronRight />}
    </div>
  );
};

export default SwiperArrow;
